import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify"; // Import toast and ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for styling

import "./ImportVraShifts.css";
import VraShiftsAPIs from "apis/panel/vraShifts/vraShifts.js";
import upload from "../../../../assets/images/rpHomePage/upload.gif";
import Context from "context/context";
import leftarrow from "assets/images/arrow-right.png";

import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import Tables from "components/table/table";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  width: "90vw",
  borderRadius: "10px",
  maxHeight: "90vh",
  overflowY: "scroll",
};

const ImportVraShifts = () => {
  const navigate = useNavigate();
  const { dispatch } = useContext(Context);
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(1);
  const [initial, setInitial] = useState(true);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const { uploadVraShiftsAPI } = VraShiftsAPIs();
  const [missingData, setMissingData] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0); // State to track upload progress

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "application/vnd.ms-excel": [".xls"],
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        handleFileUpload(acceptedFiles[0]);
      } else {
        toast.error("Only Excel files are allowed.");
      }
    },
  });

  const handleNavigation = () => {
    navigate("/panel/settings");
  };

  const handleFileUpload = async (file) => {
    const maxSize = 1024 * 1024 * 5; // 5MB
    if (file.size > maxSize) {
      // Show error message if file size exceeds the limit
      toast.error("File size exceeds the limit (5MB)", {
        toastId: "file-upload-maximum",
      });
      return;
    }

    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const response = await uploadVraShiftsAPI(file);
      dispatch({ type: "SET_LOADING", payload: false });

      if (response?.status === "SUCCESS") {
        toast.success(response?.message);
        setUploadProgress(0);
        setMissingData(response);
        setOpen(true);
        return response?.detail;
      } else {
        toast.error(response?.message);
        setUploadProgress(0);
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
      // Handle and log error
      console.error("Error uploading file:", err);
      toast.error("Error uploading file.");
    }
  };

  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          onClick={handleNavigation}
          style={{ cursor: "pointer", paddingRight: 8 }}
        >
          <img src={leftarrow} alt="Back" />
        </div>
        <Box sx={{ pt: 2, pb: 2, pl: 1 }} className="VraShiftsTitle">
        Upload VRA Schedule
        </Box>
      </div>
      <div className="containerforupload">
        <motion.div
          className="upload-area"
          {...getRootProps()}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <input {...getInputProps()} />
          <div className="instructions">
            {isDragActive ? (
              <img
                style={{ width: "40%" }}
                src={upload}
                alt="Upload indicator"
              />
            ) : (
              <>
                <img
                  style={{ width: "40%" }}
                  src={upload}
                  alt="Upload indicator"
                />
                <p style={{ color: "lightgrey" }}>
                  Drag and drop your Excel files here
                </p>
              </>
            )}
          </div>
        </motion.div>
        {uploadProgress > 0 && (
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: `${uploadProgress}%` }}
            >
              {uploadProgress}%
            </div>
          </div>
        )}
        <ToastContainer />{" "}
      </div>

    </div>
  );
};

export default ImportVraShifts;
